import { Outlet } from 'react-router-dom';

import { isAuthenticationCompleteSelector } from 'store/auth/selectors';

import { useAnalytic } from 'services/Analytics/useAnalytic';

import { useSelector } from 'hooks';
import ModalsRenderer from 'modals';

import { PageLoader } from 'components/PageLoader';

import { useAuthentication } from '../hooks/useAuthentication';
import useSessionTrackers from '../hooks/useSessionTrackers/useSessionTrackers';

const RootLayout = () => {
    const isComplete = useSelector(isAuthenticationCompleteSelector);

    useAuthentication();
    useAnalytic();
    useSessionTrackers();

    return isComplete ? (
        <>
            <Outlet />
            <ModalsRenderer />
        </>
    ) : (
        <PageLoader />
    );
};

export default RootLayout;
